/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StatContent } from '../../models/stat-content';

export interface ApiMasterStatContentGetActiveGet$Params {
}

export function apiMasterStatContentGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterStatContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StatContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterStatContentGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<StatContent>>;
    })
  );
}

apiMasterStatContentGetActiveGet.PATH = '/api/Master/StatContent/GetActive';
